import { getEntityKindMeta } from '@/utils/entity-kind-meta';

const SURFACE_KIND_META: Record<string, { icon: string; label: string }> = {
  text: { icon: getEntityKindMeta('document').icon, label: 'text' },
  canvas: { icon: getEntityKindMeta('canvas').icon, label: 'canvas' },
  audio: { icon: getEntityKindMeta('audio').icon, label: 'audio' },
};

/**
 * Shared with `SurfaceLabel` (the closed-panel pill) and the title bar's
 * breadcrumb. A generated surface looks exactly like an owned one of the same
 * kind.
 *
 * Takes the one field it reads rather than a whole `SurfaceEntry`, so a caller
 * holding only what the UI store publishes can ask too.
 */
export function surfaceMeta(entry: { surface: string }) {
  return SURFACE_KIND_META[entry.surface] ?? SURFACE_KIND_META.text;
}
